export default __webpack_public_path__ + "static/21_19-5e9e7dd5a76d2664247a05c8182b728b.png";